import React from "react";
import { MINUTE_MILLIS } from "@fidget/common/utils/timeUtils";

interface Props {
  zoneId: string;
}

interface State {
  time?: string;
}

export class CurrentGuestTime extends React.PureComponent<Props, State> {
  guestTimeUpdateTimer?: number;

  constructor(props: Props) {
    super(props);
    this.state = {
      time: this.getCurrentTime()
    };
  }

  getCurrentTime(): string | undefined {
    const options = {
      timeZone: this.props.zoneId,
      hour: "numeric",
      minute: "numeric"
    } as const;
    return new Intl.DateTimeFormat([], options).format(new Date());
  }

  componentDidMount() {
    this.guestTimeUpdateTimer = window.setInterval(() => {
      this.setState({ time: this.getCurrentTime() });
    }, MINUTE_MILLIS);
  }

  componentWillUnmount() {
    clearInterval(this.guestTimeUpdateTimer);
  }

  render() {
    return this.state.time;
  }
}
